import Header from '../../../components/header'
import Footer from '../../../components/footer'
import { useState } from "react";
import axios from "axios";
import style from './03_teachersregistration.css'
import img from '../../Images/Hero.png'

import step1 from '../../Images/account.png'
import step2 from '../../Images/search-person.png'
import step3 from '../../Images/phone-call.png'

import trust1 from '../../Images/honorable.png'
import trust2 from '../../Images/nearby.png'
import trust3 from '../../Images/10815875.png'
import trust4 from '../../Images/language.png'
import trust5 from '../../Images/phone-call_02.png'
import trust6 from '../../Images/free_02.png'
import PricingTeachers from '../../components/03_pricingteachers/03_pricingteachers';
import TeachersForm from '../../components/04_teachersform/04_teachersform';

export default function TeachersRegistration() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <Header />
                <div className='TeachersRegistationPage-HeroSection'>
                    <div className='TeachersRegistationPage-HeroSection-Info'>
                        <h1>Get Discovered by Students Worldwide.</h1>
                        <p>
                            Whether you teach singing or musical instruments, online or in person, SurSaathi helps students find and connect with you—for free. You decide your own lesson fees, and students pay you directly.
                        </p>
                        <div className='TeachersRegistationPage-HeroSection-Keys'>
                            <span>Free Listing</span>
                            <span>Online, Offline & Hybrid Teaching</span>
                            <span>No Subscription Fees</span>
                            <span>Students Contact You Directly</span>
                        </div>
                        <a href="#teachersregistrationform">Create My Free Profile</a>
                        <span>No credit card. No commissions. No hidden charges.</span>
                    </div>
                    <img src={img} alt="" />
                </div >
                <PricingTeachers />
                <div id='teachersregistrationform'></div>
                <TeachersForm />
                <div className='TeachersRegistationPage-StepsSection-Main'>
                    <h2>Get Started in 3 Simple Steps</h2>
                    <div className='TeachersRegistationPage-StepsSection-Main-Dash'></div>
                    <div className='TeachersRegistationPage-StepsSection-Flex'>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 1</span>
                            <h3>Create Your Profile</h3>
                            <p>Add your teaching details in just a few minutes.</p>
                            <img src={step1} alt="" />
                        </div>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 2</span>
                            <h3>Get Discovered</h3>
                            <p>Students search by instrument, location, language, and class mode.</p>
                            <img src={step2} alt="" />
                        </div>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 3</span>
                            <h3>Start Receiving Enquiries</h3>
                            <p>Interested students contact you directly.</p>
                            <img src={step3} alt="" />
                        </div>
                    </div>
                    <p className='TeachersRegistationPage-StepsSection-Main-P'>
                        Before creating your profile, please take a moment to read our <a href="/terms-conditions">Terms & Conditions</a> and <a href="/privacy-policies">Privacy Policy</a>. By registering on SurSaathi, you agree to our terms and policies.
                    </p>
                </div>
                <div className='TeachersRegistationPage-ForSection-Main'>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust1} alt="" />
                        <h3>Showcase Your Expertise</h3>
                        <p>
                            Display your instruments, genres, qualifications, experience, and teaching style.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust2} alt="" />
                        <h3>Reach Students Near You</h3>
                        <p>
                            Appear in searches based on your city and teaching locations.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust3} alt="" />
                        <h3>Teach Your Way</h3>
                        <p>
                            Offer online, offline, or hybrid classes.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust4} alt="" />
                        <h3>Teach in Multiple Languages</h3>
                        <p>
                            Help students find teachers they can comfortably learn from.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust5} alt="" />
                        <h3>Receive Direct Enquiries</h3>
                        <p>
                            Students contact you directly—no middlemen or commissions.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust6} alt="" />
                        <h3>Forever Free</h3>
                        <p>
                            Listing your profile and receiving enquiries will always be free.
                        </p>
                    </div>
                </div>
            <Footer />
        </div>
    );
}
